import { sendGet, sendGetWholeUrl, sendPost, sendPostWholeUrl } from "src/utils/sendApi"

export const operationConfigsApi = sendGet("v1/data/_operation_configs")

export const operationListApi = sendGet("v1/data/_operation_list")

export const operationCreateApi = sendPost("v1/data/_operation_create")

export const operationDetailsApi = (opid: string) => sendGet(`v1/data/_operation_details?opid=${opid}`)

export const operationDatasetAddApi = sendPost(`v1/data/_dataset_create`)

export const analysisDetailsApi = (anid: string) => sendGet(`v1/data/_analysis_details?anid=${anid}`)

export const analysisUpdateApi = sendPost(`v1/data/_analysis_update`)

export const analysisListApi = (opid: string) => sendGet(`v1/data/_analysis_list?opid=${opid}`)

export const analysisCreateApi = sendPost("v1/data/_analysis_create")

export const analysisDatasetApi = (anid: string) => sendGet(`v1/data/_analysis_dataset?anid=${anid}`)

export const dwtAnalysisApi = sendPostWholeUrl(`${process.env.REACT_APP_MODEL_PERMUTATION_API}/nir/analyze`)
export const dwtTransformApi = sendPostWholeUrl(`${process.env.REACT_APP_MODEL_PERMUTATION_API}/nir/transform`)
export const trainingApi = sendPostWholeUrl(`${process.env.REACT_APP_MODEL_PERMUTATION_API}/training`)
export const analysisModelSelectionApi = (anid: string) => sendPostWholeUrl(`${process.env.REACT_APP_MODEL_PERMUTATION_API}/models/${anid}/select`)
export const modelEvaluationApi = (anid: string) => sendPostWholeUrl(`${process.env.REACT_APP_MODEL_PERMUTATION_API}/evaluation/${anid}/start`)
export const trainingResultsApi = (analysis_id: string) => sendGetWholeUrl(`${process.env.REACT_APP_MODEL_PERMUTATION_API}/results/${analysis_id}`)
export const selectedModelsApi = (analysis_id: string) => sendGetWholeUrl(`${process.env.REACT_APP_MODEL_PERMUTATION_API}/models/${analysis_id}/selected_models`)
export const favoriteModelsApi = (analysis_id: string) => sendPostWholeUrl(`${process.env.REACT_APP_MODEL_PERMUTATION_API}/models/${analysis_id}/favorite`)
